import {axiosInstance} from "../instance";

const ReportList = () => {
    return axiosInstance.get('/api/report/active');
};

const ReportSave = (report) => {
    return axiosInstance.post('/api/report', report);
};

const ReportDelete = (reportId) => {
    return axiosInstance.delete(`/api/report/${reportId}`);
};

const ReportListAdmin = (filterData) => {
    return axiosInstance.post('/api/report-search', filterData);
};

const ReportAddingStatus = () => {
    return axiosInstance.get('/api/report/adding-posibility');
};

const ReportInfo = (reportId) => {
    return axiosInstance.get(`/api/report/${reportId}`);
};

const ReportInvestmentActive = (reportId) => {
    return axiosInstance.get(`/api/report/investment/active/${reportId}`);
};

const ReportCustomPrice = (reportId, prices) => {
    return axiosInstance.post(`/api/report/${reportId}/prices`, prices);
};

const ReportRecalculateInvestmentPrices = (investmentId) => {
    return axiosInstance.get(`/api/investment/${investmentId}/price-recalculate`)
};

const SendReportConfirmation = (reportId, attachment) => {
    return axiosInstance.post(`/api/report/send-confirmation/${reportId}`, attachment, {headers: {'Content-Type': 'multipart/form-data'}})
};

const ChangeReportConfirmationStatus = (data) => {
    return axiosInstance.post(`/api/report-confirmation-status`, data);
};

export {ReportInfo, ReportSave, ReportDelete, ReportList, ReportListAdmin, ReportAddingStatus, ReportCustomPrice, ReportInvestmentActive, ReportRecalculateInvestmentPrices, SendReportConfirmation, ChangeReportConfirmationStatus};
